export interface IPostRegister {
    event: IEvent;
}

export interface IRegisterResponse {
    ok: boolean;
}

export interface IEvent {
    date: Date;
    domain: string;
    country: string;
    lang: string;
    config: string;
    type: TEvent;
    subtype?: TEventSubtype;
    session?: string;
    cmp_version: number;
    gvl_version: number;
    tc_date: Date;
    tc_string?: string;
}

export enum TEvent {
    APARECE_GDPR            = 1,
    APARECE_CMP             = 2,
    ACEPTAR_TODO            = 3,
    CONFIGURAR              = 4,
    GUARDAR                 = 5,
    // CLICK_TAB_VENDORS       = 6,
    // CLICK_TAB_PURPOSES      = 7,
    // CLICK_TAB_PURPOSES_LI   = 8,
    SHOW_SIMPLY_VENDORS     = 9,
    RECHAZAR_TODO           = 10,
    CIERRA_CMP              = 11,
    APARECE_INSIST          = 12,
    PLATFORM_APPROVE        = 13,
    FINALIZAR               = 14,
    APARECE_AUTO_ACCEPT     = 15,
}

export enum TEventSubtype {
    TODO_ACEPTADO       = 1,
    TODO_RECHAZADO      = 2,
    CONFIGURADO         = 3,
    FIRST_LAYER         = 4,
    SECOND_LAYER        = 5,
    INSIST_LAYER        = 6,
    REG_SUB             = 7,
    LOGIN               = 8,
    ANY                 = 9,
    AUTO_ACCEPT_LAYER   = 10,
}

export interface IToPublicEvent {
    type: TEvent;
    subtype?: TEventSubtype;
}
